import * as types from '../constants/bookingConstants';

const initialState = {
  details: {},
  apiCallInProgress: false
};

export default function booking(state = initialState, action) {
  switch (action.type) {
    case types.GET_BOOKING_DATA_SUCCESS:
      return Object.assign({}, state, { details: action.response, error: null });
    case types.GET_BOOKING_AVAILABILITY_SUCCESS:
      return Object.assign({}, state, { bookingAvailability: action.response });
    case types.JOBID_NOT_FOUND:
      return Object.assign({}, state, { details: {}, error: null });
    case types.CONFIRM_BOOKING_ERROR:
      return Object.assign({}, state, { error: action.response });
    case types.API_CALL_INPROGRESS:
      return Object.assign({}, state, { apiCallInProgress: action.response });
    case types.GET_JOB_DATA_SUCCESS:
      return Object.assign({}, state, { jobinfo: action.response, error: null });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/booking/reducers/booking.js